"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TVA_UNIT = exports.StockManagementType = exports.RPD_UNIT = exports.PricerManagementType = exports.ProduitType = exports.ConversionOperator = exports.AttributeType = void 0;
/** The type of the attribute */
var AttributeType;
(function (AttributeType) {
    AttributeType["Number"] = "number";
    AttributeType["Boolean"] = "boolean";
    AttributeType["Textarea"] = "textarea";
    AttributeType["Simpleselect"] = "simpleselect";
    AttributeType["Multiselect"] = "multiselect";
    AttributeType["Table"] = "table";
    AttributeType["Metric"] = "metric";
    AttributeType["Text"] = "text";
    AttributeType["ReferenceEntityCollection"] = "reference_entity_collection";
    AttributeType["Identifier"] = "identifier";
    AttributeType["Date"] = "date";
    AttributeType["PriceCollection"] = "price_collection";
    AttributeType["ReferenceEntity"] = "reference_entity";
})(AttributeType || (exports.AttributeType = AttributeType = {}));
/** Mathematical operator for unit conversion */
var ConversionOperator;
(function (ConversionOperator) {
    ConversionOperator["Add"] = "add";
    ConversionOperator["Sub"] = "sub";
    ConversionOperator["Mul"] = "mul";
    ConversionOperator["Div"] = "div";
})(ConversionOperator || (exports.ConversionOperator = ConversionOperator = {}));
var ProduitType;
(function (ProduitType) {
    ProduitType["PACK"] = "Pack";
    ProduitType["SINGLE"] = "SingleProduct";
})(ProduitType || (exports.ProduitType = ProduitType = {}));
var PricerManagementType;
(function (PricerManagementType) {
    PricerManagementType["PRICER"] = "pricer";
})(PricerManagementType || (exports.PricerManagementType = PricerManagementType = {}));
var RPD_UNIT;
(function (RPD_UNIT) {
    RPD_UNIT["UNIT"] = "\u20AC/unit";
    RPD_UNIT["KG"] = "\u20AC/kg";
    RPD_UNIT["L"] = "\u20AC/l";
    RPD_UNIT["T"] = "\u20AC/t";
})(RPD_UNIT || (exports.RPD_UNIT = RPD_UNIT = {}));
var StockManagementType;
(function (StockManagementType) {
    StockManagementType["STOCK_MANAGED"] = "managed";
    StockManagementType["STOCK_NOT_MANAGED"] = "notManaged";
})(StockManagementType || (exports.StockManagementType = StockManagementType = {}));
var TVA_UNIT;
(function (TVA_UNIT) {
    TVA_UNIT["POURCENT"] = "%";
})(TVA_UNIT || (exports.TVA_UNIT = TVA_UNIT = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9fdGVtcC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQjs7Ozs7OztHQU9HOzs7QUEwREgsZ0NBQWdDO0FBQ2hDLElBQVksYUFjWDtBQWRELFdBQVksYUFBYTtJQUN2QixrQ0FBaUIsQ0FBQTtJQUNqQixvQ0FBbUIsQ0FBQTtJQUNuQixzQ0FBcUIsQ0FBQTtJQUNyQiw4Q0FBNkIsQ0FBQTtJQUM3Qiw0Q0FBMkIsQ0FBQTtJQUMzQixnQ0FBZSxDQUFBO0lBQ2Ysa0NBQWlCLENBQUE7SUFDakIsOEJBQWEsQ0FBQTtJQUNiLDBFQUF5RCxDQUFBO0lBQ3pELDBDQUF5QixDQUFBO0lBQ3pCLDhCQUFhLENBQUE7SUFDYixxREFBb0MsQ0FBQTtJQUNwQyxxREFBb0MsQ0FBQTtBQUN0QyxDQUFDLEVBZFcsYUFBYSw2QkFBYixhQUFhLFFBY3hCO0FBMEJELGdEQUFnRDtBQUNoRCxJQUFZLGtCQUtYO0FBTEQsV0FBWSxrQkFBa0I7SUFDNUIsaUNBQVcsQ0FBQTtJQUNYLGlDQUFXLENBQUE7SUFDWCxpQ0FBVyxDQUFBO0lBQ1gsaUNBQVcsQ0FBQTtBQUNiLENBQUMsRUFMVyxrQkFBa0Isa0NBQWxCLGtCQUFrQixRQUs3QjtBQTRTRCxJQUFZLFdBR1g7QUFIRCxXQUFZLFdBQVc7SUFDckIsNEJBQWEsQ0FBQTtJQUNiLHVDQUF3QixDQUFBO0FBQzFCLENBQUMsRUFIVyxXQUFXLDJCQUFYLFdBQVcsUUFHdEI7QUF5ZkQsSUFBWSxvQkFFWDtBQUZELFdBQVksb0JBQW9CO0lBQzlCLHlDQUFpQixDQUFBO0FBQ25CLENBQUMsRUFGVyxvQkFBb0Isb0NBQXBCLG9CQUFvQixRQUUvQjtBQUVELElBQVksUUFLWDtBQUxELFdBQVksUUFBUTtJQUNsQixnQ0FBZSxDQUFBO0lBQ2YsNEJBQVcsQ0FBQTtJQUNYLDBCQUFTLENBQUE7SUFDVCwwQkFBUyxDQUFBO0FBQ1gsQ0FBQyxFQUxXLFFBQVEsd0JBQVIsUUFBUSxRQUtuQjtBQUVELElBQVksbUJBR1g7QUFIRCxXQUFZLG1CQUFtQjtJQUM3QixnREFBeUIsQ0FBQTtJQUN6Qix1REFBZ0MsQ0FBQTtBQUNsQyxDQUFDLEVBSFcsbUJBQW1CLG1DQUFuQixtQkFBbUIsUUFHOUI7QUFFRCxJQUFZLFFBRVg7QUFGRCxXQUFZLFFBQVE7SUFDbEIsMEJBQWMsQ0FBQTtBQUNoQixDQUFDLEVBRlcsUUFBUSx3QkFBUixRQUFRLFFBRW5CIn0=